import { IElementsAGN, IElementsAGO } from 'api/Assessor/quorum';
interface TabelaState {
  AGNData: Array<IElementsAGN>;
  AGOData: Array<IElementsAGO>;
  rows: Array<IElementsAGN | IElementsAGO>;
  page: number;
  size: number;
  count: number;
  loading: boolean;
}

type TabelaActionType =
  | 'setRow'
  | 'setPage'
  | 'setSize'
  | 'setCount'
  | 'setAGNData'
  | 'setAGOData'
  | 'setLoading';

interface TabelaAction {
  type: TabelaActionType;
  value: any;
}

export const tabelaInitialState: TabelaState = {
  AGOData: [],
  AGNData: [],
  rows: [],
  page: 1,
  size: 10,
  count: 0,
  loading: false,
};

export const tabelaReducer = (
  state: TabelaState,
  action: TabelaAction
): TabelaState => {
  switch (action.type) {
    case 'setRow':
      return { ...state, rows: action.value };
    case 'setPage':
      return { ...state, page: action.value };
    case 'setSize':
      return { ...state, size: action.value };
    case 'setCount':
      return { ...state, count: action.value };
    case 'setAGOData':
      return { ...state, AGOData: action.value };
    case 'setAGNData':
      return { ...state, AGNData: action.value };
    case 'setLoading':
      return { ...state, loading: action.value };
    default:
      return state;
  }
};
